import { getTranslatedField, getI18n } from '@/plugins/i18n'

export const codeNameDisplayExpr = (item) => {
  let text = item && item.code ? item.code : ''
  const name = item && (item.name || getTranslatedField(item, 'name'))
  if (name) {
    text += text ? ' - ' : ''
    text += name
  }
  return text
}

export const customerDisplayExpr = (item, withNumber = false) => {
  let text = item?.name ? item.name : ''
  if (item?.name_ext) {
    text += text ? ' ' : ''
    text += item.name_ext
  }
  if (!withNumber && item?.vat_number) {
    text += text ? ' - ' : ''
    text += item.vat_number
  }

  if (withNumber && item?.mobile) {
    text += text ? ' - ' : ''
    text += item.mobile
  }

  return text
}

export const formatTime = (date) => {
  return new Intl.DateTimeFormat(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date))
}

export const formatDateTime = (date) => {
  return new Intl.DateTimeFormat(undefined, {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date))
}

export function booleanDisplayExpr(value) {
  const i18n = getI18n()
  const isTrue = value === true || value === 'true'
  return isTrue ? i18n.t('common.yes') : i18n.t('common.no')
}
